<template>
  <div v-if="transaction">
    <user-details
      :data-user.sync="transaction.source_user"
      title="Recipient Details"
      hide-actions
    />
    <user-details
      v-if="transaction.direct_payment"
      :data-user.sync="transaction.direct_payment.initiator"
      title="Sender Details"
      hide-actions
    />
    <individual-mobile-money-details class="mt-5" :transaction.sync="transaction" />
    <cashout-details
      :dataTransaction.sync="transaction"
      class="mt-5"
      @reloadCashout="reloadCashout"
    />
    <blockchain-transaction :transaction.sync="transaction" />
    <!-- <cashout-documents :cashout.sync="transaction" class="mt-3" /> -->
  </div>
</template>
<script>
import UserDetails from "@/app/users/detail";
import CashoutDetails from "./details";
import BlockchainTransaction from "../../transfers/blockchaintransactions.vue";
import IndividualMobileMoneyDetails from "@/app/accounts/mobilemoney/CashoutMobileMoneyAccounts.vue";

export default {
  components: {
    UserDetails,
    CashoutDetails,
    BlockchainTransaction,
    IndividualMobileMoneyDetails,
    //    CashoutDocuments
  },
  props: {
    id: { required: true },
  },
  data: () => ({
    transaction: null,
  }),

  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      await this.$http
        .get(`api/v1/cashout/${this.id}`)
        // eslint-disable-next-line arrow-parens
        .then((data) => {
          this.transaction = data;
        })
        .catch(() => window.Notify.warning("Something went wrong while fetching cashout details"));
    },
    async reloadCashout() {
      await this.fetchData();
    },
  },
};
</script>
